module.exports = __webpack_public_path__ + "static/media/SenthVyra_Resume.8b1d22ab.pdf";